import React, {useEffect} from 'react';
import {useSnackbar} from 'notistack';
import {useAuth} from '../context/AuthContext';

const useHandleErrors = errors => {
    const {LogOut} = useAuth();
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    useEffect(() => {
        if (errors) {
            
            if (!Boolean(errors?.response)) {
                // if (errors.code === 'ERR_BAD_REQUEST') {
                //     enqueueSnackbar('Recursos indisponível');
                // }

                if(errors.code === 'ECONNABORTED'){
                    enqueueSnackbar('Tempo de operação esgotado')
                }

                if(errors.code === 'ERR_NETWORK'){
                    enqueueSnackbar('Servidor instável');
                }

                return;
            }

            switch (errors?.response?.status) {
                case 401:
                    LogOut();
                    break;
                case 402: 
                    enqueueSnackbar(errors.response.data.message);
                    break;
                case 404:
                    enqueueSnackbar(errors.response?.data?.message || 'Recurso indisponível');
                    break;
                case 200:
                    enqueueSnackbar(errors.response.data.message);
                    break;
                case 0:
                    enqueueSnackbar('Servidor desconectado.');
                    break;
                default:
                    if (errors.response) {
                        if (errors.response.data.message) {
                            enqueueSnackbar(errors.response.data.message);
                        } else {
                            enqueueSnackbar(errors.response.message);
                        }
                    } else {
                        enqueueSnackbar(errors.message);
                    }
                    break;
            }
        }
    }, [errors]);
};

export default useHandleErrors;
